webpackJsonp([215179860267484],{

/***/ 375:
/***/ (function(module, exports) {

	// noop


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin: 80px 0 20px 0;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin: 80px 0 20px 0;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  border-right: 1px solid #ccc;\n  padding: 3px 10px 0 0;\n  width: 50%;\n  font-size: 0.9rem;\n  letter-spacing: 0.2em;\n  line-height: 1.4;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  text-align: right;\n  border-right: 1px solid #ccc;\n  padding: 3px 10px 0 0;\n  width: 50%;\n  font-size: 0.9rem;\n  letter-spacing: 0.2em;\n  line-height: 1.4;\n  justify-content: center;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  padding: 3px 0 0 10px;\n  width: 50%;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  padding: 3px 0 0 10px;\n  width: 50%;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  justify-content: center;\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProjectSummaryWrapper = _styledComponents2.default.div(_templateObject);
	var ProjectSummaryLeft = _styledComponents2.default.div(_templateObject2);
	var ProjectSummaryRight = _styledComponents2.default.div(_templateObject3);
	
	var ProjectSummary = function ProjectSummary(_ref) {
	  var projectData = _ref.projectData;
	
	  return _react2.default.createElement(
	    ProjectSummaryWrapper,
	    null,
	    _react2.default.createElement(
	      ProjectSummaryLeft,
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        projectData.wie !== "" ? 'WIE' : ''
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        projectData.wat !== "" ? 'WAT' : ''
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        projectData.waar !== "" ? 'WAAR' : ''
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        projectData.wanneer !== "" ? projectData.type === 'inOpbouw' ? 'STATUS' : 'WANNEER' : ''
	      )
	    ),
	    _react2.default.createElement(
	      ProjectSummaryRight,
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        projectData.wie
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        projectData.wat
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        projectData.waar
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        projectData.wanneer
	      )
	    )
	  );
	};
	
	exports.default = ProjectSummary;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: sticky;\n  background-color: #fff;\n  top: 160px;\n  z-index: 3;\n'], ['\n  position: sticky;\n  background-color: #fff;\n  top: 160px;\n  z-index: 3;\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyPluginReactHelmet = __webpack_require__(375);
	
	var _gatsbyPluginReactHelmet2 = _interopRequireDefault(_gatsbyPluginReactHelmet);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Navigation = __webpack_require__(21);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _ProjectSummary = __webpack_require__(199);
	
	var _ProjectSummary2 = _interopRequireDefault(_ProjectSummary);
	
	var _styles = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Sticky = _styledComponents2.default.div(_templateObject);
	
	var Template = function Template(_ref) {
	  var data = _ref.data,
	      location = _ref.location,
	      pathContext = _ref.pathContext;
	
	  var navItems = data.allNavigationJson.edges;
	  var subProjectItems = navItems.filter(function (_ref2, index) {
	    var navItem = _ref2.node;
	    return index === 0;
	  });
	  var projects = data.allProjectenJson.edges[0];
	  var project = projects.node.projecten.filter(function (prjct) {
	    return pathContext.id === prjct.id;
	  })[0];
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      Sticky,
	      null,
	      _react2.default.createElement(_Navigation2.default, { items: subProjectItems, navType: 'sub' })
	    ),
	    _react2.default.createElement(
	      _styles.ProjectWrapper,
	      null,
	      _react2.default.createElement(_ProjectSummary2.default, { projectData: project }),
	      project.afbeeldingen && project.afbeeldingen.map(function (afbeelding, index) {
	        return _react2.default.createElement(_styles.ProjectImage, { key: index, src: afbeelding.image, alt: '' });
	      })
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = Template;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-project-tpl-js-3d71f1fe6d0e7dc88018.js